"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHomeFeatures = void 0;
exports.defaultHomeFeatures = [
    {
        link: '#',
        name: 'Woodgreen Estate | HKD 98M',
        image: 'https://www.okay.com/images/home-bg.webp'
    }, {
        link: '#',
        name: 'Hong Lok Yuen - 9th Street | HKD 58M',
        image: 'https://images.okay.com/property/wp1800_1200/hong-lok-yuen-9th-street-tai-po-for-sale-407183_637957453640902139.webp'
    }, {
        link: '#',
        name: 'Providence Bay - Phase 1 | HKD 16M',
        image: 'https://images.okay.com/property/wp1800_1200/hong-lok-yuen-9th-street-tai-po-for-sale-407183_637957453962130907.webp'
    }
];
